import React, { memo } from 'react'

import { Icon, AIGenerated2 } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18nThreeDStudio'

const FEATURE_KEYS = ['private', 'dccBridge', 'export', 'multipleModels']

// Advanced-features list shown inside the paid-feature upgrade modal, below the
// base subscription bullets. locale is injected (not read from context) so it
// matches the store-agnostic UpgradeCard that renders it.
function AdvancedFeaturesList({ locale = 'en' }) {
  const t = (key, options) => i18n.t(key, { ns: 'three-d-studio', lng: locale, ...options })

  return (
    <div className="advanced-features">
      <p className="advanced-features__title cgt-body-base-semibold">
        {t('usageModal.paidFeature.advancedFeaturesTitle')}
      </p>
      <ul className="advanced-features__list">
        {FEATURE_KEYS.map((key) => (
          <li key={key} className="advanced-features__item">
            <Icon
              svgComponent={AIGenerated2}
              className="advanced-features__icon"
              color="primary"
              size="small"
              notSpaced
            />
            <span className="cgt-body-base">
              {t(`usageModal.paidFeature.advancedFeatures.${key}`)}
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}

AdvancedFeaturesList.propTypes = {
  locale: string,
}

export default memo(AdvancedFeaturesList)
